__turbopack_context__.v({
  "collapse": "CwGKJG_collapse",
  "expandButton": "CwGKJG_expandButton",
  "isHorizontalOnMobile": "CwGKJG_isHorizontalOnMobile",
  "isMultiline": "CwGKJG_isMultiline",
  "list": "CwGKJG_list",
  "word": "CwGKJG_word",
});
